import { ConvertMillimetersToCentimeters, ConvertCentimetersToMillimeters } from '@/utils/converters';

import request from '@/utils/request';

export function getSuggestions(searchQuery) {
  return request({
    params: searchQuery,
    method: 'get',
    url: 'store/getSuggestions'
  });
}

export function getStoreConfiguration() {
  return request({
    method: 'get',
    url: 'store/getStoreConfiguration'
  });
}

function transformItem2Dto(item) {
  const dto = {
    ...item,
    storeID: item.id,
    heightInMm: ConvertCentimetersToMillimeters(item.height)
  };
  delete dto.id;
  delete dto.height;
  // Code must be unique, but is not required. If it is equal to an empty string,
  // for instance when the user erases a previously filled in value, just set it
  // to null to avoid uniqueness errors.
  if (dto.code === '') {
    dto.code = null;
  }
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.storeID,
    height: ConvertMillimetersToCentimeters(dto.heightInMm)
  };
  delete item.storeID;
  delete item.heightInMm;
  return item;
}

export const storeExtensions = {
  actions: {
    getSuggestions({ commit, dispatch }, searchQuery) {
      return new Promise((resolve, reject) =>
        getSuggestions(searchQuery)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getStoreConfiguration({ commit, dispatch }, searchQuery) {
      return new Promise((resolve, reject) =>
        getStoreConfiguration()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};

export const apiOverrides = { transformItem2Dto, transformDto2Item };
